import { z } from "zod";
import { jobIdSchema, localTimeSchema, requestedDateSchema } from "./job-schemas";

export const jobReplacementIdempotencyKeySchema = z
  .string()
  .regex(/^[A-Za-z0-9][A-Za-z0-9._:-]{7,127}$/u);

export const createJobReplacementInputSchema = z.strictObject({
  requestedDate: requestedDateSchema,
  requestedStartTime: localTimeSchema,
  requestedEndTime: localTimeSchema,
});

export const jobReplacementDraftSchema = z.strictObject({
  id: jobIdSchema,
  sourceJobId: jobIdSchema,
  jobStatus: z.literal("DRAFT"),
  versionNo: z.literal(1),
});

export const createJobReplacementResponseSchema = z.discriminatedUnion("status", [
  z.strictObject({
    status: z.literal("created"),
    replacement: jobReplacementDraftSchema,
  }),
  z.strictObject({
    status: z.literal("existing"),
    replacement: jobReplacementDraftSchema,
  }),
]);

export type CreateJobReplacementInput = z.infer<typeof createJobReplacementInputSchema>;
export type JobReplacementDraft = z.infer<typeof jobReplacementDraftSchema>;
export type CreateJobReplacementResponse = z.infer<typeof createJobReplacementResponseSchema>;
